module.exports = __webpack_public_path__ + "static/media/icon-company-white.d0be8590.svg";